import { Tooltip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { useHistoryNavigate } from "../../../../../../../../../hooks/useHistoryNavigate";
import HNSColors from "../../../../../../../../ui library/HNSColors";
import { COL_CONTENT_MAX_LENGTH } from "../../utils/consts";
import { STRINGS } from "../../utils/strings";

const ClientType = ({ clientObj }) => {
  const { navigationHistoryService } = useHistoryNavigate();
  const fullText = clientObj?.value ?? "";
  const displayText =
    fullText.length > COL_CONTENT_MAX_LENGTH
      ? `${fullText.slice(0, COL_CONTENT_MAX_LENGTH)}...`
      : fullText;

  const navigateToDetail = (caseId) => {
    window.open(
      `/client-detail/${caseId}${navigationHistoryService.get("client-detail")}`,
      "_blank"
    );
  };

  return (
    <Tooltip title={fullText || STRINGS.TOOLTIP_CLIENT_LINK}>
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          navigateToDetail(clientObj.id);
        }}
        className="text-left underline"
        style={{
          color: `var(--report-link-color, ${HNSColors.primary[500]})`,
          transition: "color 150ms ease",
        }}
      >
        {displayText}
      </Link>
    </Tooltip>
  );
};
export default ClientType;
